import { Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { SidebarService } from '@ibe/services/ui';
import { BookingService } from '@ibe/services';
import { INDRAAncillariesService } from '@ibe.services/ancillaries.indra.service';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { input } from 'modernizr';
import { INDRAGoogleAnalyticsService, EVENT_ACTION_CLICK, EVENT_PRODUCT_BRAND_CARBON_OFFSET, EVENT_PRODUCT_BRAND_DANISH_FUND, EVENT_PRODUCT_BRAND_CHUBB_INSURANCE, EVENT_PRODUCT_BRAND_CARS, EVENT_ACTION_REM_CART, EVENT_PRODUCT_BRAND_HOTELS } from '@ibe.services/google.analytics.indra.service';
import { SESSION_VAR_KEY_CURRENCY } from '@ibe.config';

@Component({
	selector: 'app-card-extras-full-width',
	templateUrl: './card-extras-full-width.indra.component.html',
	styleUrls: ['./card-extras-full-width.component.scss']
})
export class INDRACardExtrasFullWidthComponent implements OnInit {
	@Input() classes: string;
	@Input() logoFilename: string;
	@Input() title: string;
	@Input() titleKey: string;
	@Input() description: string;
	@Input() descriptionKey: string;
	@Input() info: string;
	@Input() infoKey: string;
	@Input() confirmation: string;
	@Input() confirmationKey: string;
	@Input() price: string = null;
	@Input() stars: number = null;
	@Input() oldprice: string = null;
	@Input() label: string;
	@Input() labelKey: string;
	@Input() image: string = '';
	@Input() externalLink: string = null;
	@Input() isAdded: boolean;
	@Input() showPrice: boolean = false;
	@Input() closeButton: boolean = true;
	@Input() sidebar: any = null;
	@Input() modifierButton: string = '';
	@Input() disabled: boolean = false;
	@Input() insuranceDescription: string;
	@Input() toolTipText?: string;
	@Input() hasExtraInfo?: boolean = false;
	
	@Output() extraChanged = new EventEmitter<string>();
	@Output() isShowError = new EventEmitter<boolean>();
	@Output() openSidebar = new EventEmitter();

	isLoading = true;

	constructor(
		private sidebarService: SidebarService,
		private bookingService: BookingService,
		private cdr: ChangeDetectorRef,
		private ancillaryService: INDRAAncillariesService,
		private bfmStorage: INDRABFMDataStorageService,
		private googleAnalytics: INDRAGoogleAnalyticsService
	) { }

	ngOnInit() {
		// setTimeout(() => {
			this.isLoading = false;
			this.cdr.markForCheck();
		// }, 3000);
	}

	INDRA_sidebarOpen() {
		if(this.sidebar !== null) {
			this.sidebarService.openSidebar(this.sidebar);
			this.INDRA_registerGAselectExtra();
		} else {
			this.openSidebar.emit();
			this.INDRA_registerGAselectExtra();
		}
	}

	INDRA_extraChanged() {
		if (this.classes === 'rent-a-car') {
			this.bookingService.removeExtra(this.classes);
			this.INDRA_removeGA_Extra(EVENT_PRODUCT_BRAND_CARS, this.classes);
		} else if (this.classes === 'hotel') {
			// this prevents opening sidebar while waiting for remove hotel api
			this.sidebar = null;
			this.extraChanged.emit('hotel');
			this.INDRA_removeGA_Extra(EVENT_PRODUCT_BRAND_HOTELS, this.classes)
		} 
	}

	INDRA_removeGA_Extra(type, extra) {
		const eventDataLayerObject = this.googleAnalytics.INDRA_createGA_ExternalAncillarySingleProduct(type, extra);
		eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(EVENT_ACTION_REM_CART);

		this.googleAnalytics.INDRA_GA_removeFromCart(sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY), eventDataLayerObject);
	}

	INDRA_printStars() {
		return new Array(Math.floor(this.stars));
	}

	INDRA_registerGAselectExtra() {
		let brand;
		const amount = this.price.split(' ');
		let extra = {
			amount: amount[0]
		};

		if (this.sidebar) {
			switch (this.sidebar[0]) {
				case 'carbon-offset':
					brand = EVENT_PRODUCT_BRAND_CARBON_OFFSET;
					extra['bookableItemId'] = 'CO_001';
					extra['description'] = 'carbon offset';
					break;
				case 'danish-guarantee-fund':
					brand = EVENT_PRODUCT_BRAND_DANISH_FUND;
					extra['bookableItemId'] = 'DR_001';
					extra['description'] = 'danish guarantee fund';
					break;
				default:
					break;
			}
		} else if (this.insuranceDescription) {
			brand = EVENT_PRODUCT_BRAND_CHUBB_INSURANCE;
			extra['bookableItemId'] = '2224UMFV';
			extra['description'] = this.insuranceDescription;
		}

		let eventDataLayerObject = this.googleAnalytics.INDRA_createGA_ExternalAncillarySingleProduct(brand, extra);
		eventDataLayerObject.actionField = this.googleAnalytics.INDRA_createGA_ActionField(EVENT_ACTION_CLICK);

		this.googleAnalytics.INDRA_GA_productClick(eventDataLayerObject, sessionStorage.getItem(SESSION_VAR_KEY_CURRENCY));
	}
}



